import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { VehicleDefectCode } from '@/types/vehicle-defect-code'

export function getVehicleDefectCodes(): Promise<
  AxiosResponse<VehicleDefectCode[]>
> {
  return instance.get(`/vehicle-defect-code`)
}
